module.exports = __webpack_public_path__ + "static/media/special-star.5b84a075.png";